import { styled } from '@mui/material';
import { Colors } from '../styles/colors';

export const StyledMultiStepIconRoot = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean };
  isDisabled: boolean;
}>(({ ownerState, isDisabled }) => ({
  backgroundColor: Colors.White,
  zIndex: 1,
  color: Colors.Blue,
  width: 45,
  height: 45,
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: Colors.Blue,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  transition: 'border 0.1s ease-in-out 0s, cursor 0.3s', // Add transition for transform

  '&:hover': !isDisabled && {
    cursor: 'pointer',
    // transform: 'scale(1.03)', // Scale up by 10% on hover
    backgroundImage: `linear-gradient(150deg, rgba(0,54,64,1) 1%, rgba(0,74,88,1) 38%, ${Colors.Blue} 100%)`,
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    outline: `${Colors.Blue} solid 2px`,
    border: '3px solid white',
    color: Colors.White,
  },

  ...(ownerState &&
    ownerState.active && {
      backgroundImage: `linear-gradient(150deg, rgba(0,54,64,1) 1%, rgba(0,74,88,1) 38%, ${Colors.Blue} 100%)`,
      boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
      outline: `${Colors.Blue} solid 2px`,
      border: '3px solid white',
      color: Colors.White,
    }),
  ...(ownerState &&
    ownerState.completed && {
      backgroundImage: `linear-gradient(150deg, rgba(0,54,64,1) 1%, rgba(0,74,88,1) 38%, ${Colors.Blue} 100%)`,
      color: Colors.White,
      border: 'none',
      '&:hover': !isDisabled && {
        cursor: 'pointer',
        // transform: 'scale(1.03)', // Scale up by 10% on hover
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
        outline: `${Colors.Blue} solid 2px`,
        border: '3px solid white',
        color: Colors.White,
      },
    }),
}));
